import { Controller, useForm } from 'react-hook-form';
import clsx from 'clsx';
import { useLoginStore } from '@lib/store';
import type { LoginResponse } from '@shared/api/rest/auth';
import { ButtonV2, ErrorMessage, Input, Radio } from '@shared/widgets';

interface IForm {
  deviceId: string;
  factor: 'passcode';
  passcode: string;
}

interface IDUOFormProps {
  className?: string;
  devices: LoginResponse['devices'];
  token: LoginResponse['temp_token'];
}

export const DUOForm = (props: IDUOFormProps) => {
  const loginStore = useLoginStore();

  const { control, formState, handleSubmit, watch } = useForm<IForm>({
    defaultValues: { deviceId: props.devices?.[0]?.device || '', factor: 'passcode', passcode: '' },
  });
  const passcode = watch('passcode');

  const submitHandler = (data: IForm) => loginStore.twoFactor({ factor: data.factor, passcode: data.passcode, temp_token: props.token! });

  const multipleDevices = props.devices && props.devices.length > 1;
  return (
    <div>
      <form className='flex flex-col' onSubmit={handleSubmit(submitHandler)}>
        <div className='relative flex items-center justify-start' />
        {multipleDevices && (
          <div className='my-6'>
            <div className='mb-4 text-center text-[#766750]'>SELECT YOUR DEVICE</div>
            <div>
              {props.devices!.map((device, idx) => (
                <div key={device.device} className={clsx('p-4 pr-1', idx && 'border-t border-t-[#443e35]')}>
                  <Controller
                    name='deviceId'
                    control={control}
                    render={({ field: { value, onChange } }) => (
                      <Radio
                        right
                        fullWidth
                        name='device'
                        disabled={formState.isSubmitting}
                        value={device.device}
                        checked={value === device.device}
                        onChange={(value) => onChange(value)}
                      >
                        {device.display_name}
                      </Radio>
                    )}
                  />
                </div>
              ))}
            </div>
          </div>
        )}
        <div>
          <div className='mb-10'>
            <Controller
              name='passcode'
              control={control}
              rules={{ required: 'This field is required' }}
              render={({ field, fieldState: { error } }) => (
                <>
                  <Input {...field} className='!h-[48px]' variant='outlined' placeholder='Masterkey passcode' />
                  <ErrorMessage text={error?.message} />
                </>
              )}
            />
          </div>
          <ButtonV2 className='!h-[56px]' fullWidth type='submit' disabled={!passcode}>
            Submit
          </ButtonV2>
        </div>
      </form>
    </div>
  );
};
